require('./mainErrorService');
require('./serverTimeService');
require('./ipAddressService');
require('./currentUser/currentUser');

angular.module('app.httpInterceptors', [
  'app.mainErrorService',
  'app.serverTimeService',
  'app.ipAddressService',
  'app.currentUser'
])

  .config([
    '$httpProvider',
    function ($httpProvider) {
      'use strict';

      return $httpProvider.interceptors.push(
        'countHttpConnections',
        'appendHeaders',
        'updateSession',
        'errorHandler',
        'checkUserLoginStatus'
      );
    }
  ])

  .factory('httpConnectionCounter', [
    function () {
      'use strict';

      let counter;
      return counter = {
        count: 0,
        increment: function () {
          if (counter.count < 0) {
            counter.count = 0;
          }
          return counter.count += 1;
        },
        decrement: function () {
          if (counter.count < 0) {
            counter.count = 0;
          }
          return counter.count -= 1;
        }
      };
    }])

  .factory('countHttpConnections', [
    'httpConnectionCounter',
    function (httpConnectionCounter) {
      'use strict';

      return {
        request: function (config) {
          httpConnectionCounter.increment();
          return config;
        },
        response: function (config) {
          httpConnectionCounter.decrement();
          return config;
        },
        responseError: function (config) {
          httpConnectionCounter.decrement();
          return config;
        }
      };
    }
  ])

  .factory('appendHeaders', [
    'appKey', 'ipAddress', 'PRODUCT', 'hostnameMatchService',
    function (appKey, ipAddress, product, hostnameMatchService) {
      'use strict';

      return {
        request: function (config) {
          if (config.url.match(/.+\.[hockeytv].+/)
            || config.url.match(/.+\.[ahltv].+/)
            || config.url.match(/:\/\/localhost/)) {

            config.headers['APP_KEY'] = appKey.app_key;
            config.headers['API_KEY'] = appKey.user_key;
            config.headers['APP_ID'] = appKey.app_id;
            config.headers['PLATFORM'] = window.location.platform(undefined, hostnameMatchService.hostname());
            config.headers['UI_VERSION'] = window.uiVersion;
            config.headers['PRODUCT_ID'] = product.Id;
            // config.headers['IP_ADDRESS'] = ipAddress.address ? ipAddress.address : '';

            if (config.url.match(/.+\.dev\.hockeytv\.com/)) {
              config.headers['Authorization'] = 'Basic c3RhZmY6b3ZlcnR1cmU=';
            }
          }
          return config;
        }
      };
    }
  ])

  .factory('updateSession', [
    '$injector',
    function ($injector) {
      'use strict';

      return {
        last_update: null,
        request: function (config) {
          let currentUser;

          if (config.url.match(/.+\.hockeytv\.com/)
            || config.url.match(/:\/\/localhost:8081/)) {
            if (!currentUser) {
              currentUser = $injector.get('currentUser');
            }

            if (!currentUser.last_updated_session) {
              currentUser.last_updated_session = new Date().getTime();
            }

            let currentTime = new Date().getTime();

            if ((currentTime - currentUser.last_updated_session) >= 300000) {
              config.headers['session_data'] = 'update_session';
              currentUser.last_updated_session = new Date().getTime();
            }
          }
          return config;
        },

        response: function (config) {
          let currentUser;

          if (config.config.url.match(/api(\.[a-zA-Z0-9_-]+)?\.hockeytv\.com/)
            || config.config.url.match(/:\/\/localhost:8081/)) {
            let headers = config.headers();
            if (!currentUser) {
              currentUser = $injector.get('currentUser');
            }

            if (typeof headers['session_data'] !== 'undefined') {
              let sessionDataJson = headers['session_data'];
              let session_data = sessionDataJson === 'null' ? null : (sessionDataJson ? JSON.parse(sessionDataJson) : null);
              currentUser.set_data(session_data, null);
            }
          }
          return config;
        }
      };
    }
  ])

  .factory('errorHandler', [
    'mainError', 'serverTime',
    function (mainError, serverTime) {
      'use strict';

      return {
        response: function (config) {
          let server_time;
          server_time = config.headers('SERVER_TIME');
          if (server_time) {
            serverTime.set(server_time);
          }
          if (config.data && config.data.error) {
            mainError.set(config.data.error, 'warning');
          }
          return config;
        },
        responseError: function (config) {
          if (config.data && config.data.error) {
            mainError.set(config.data.error, 'error');
          }
          return config;
        }
      };
    }
  ])

  .factory('checkUserLoginStatus', [
    'hostnameMatchService', '$rootScope',
    function (hostnameMatch, $rootScope) {
      'use strict';

      return {
        response: function (config) {
          if (hostnameMatch.is_api(config.config.url)) {
            if (config.headers('USER_LOGGED_IN') !== null) {
              let user_logged_in = parseInt(config.headers('USER_LOGGED_IN'));
              if (user_logged_in !== 1) {
                $rootScope.$broadcast('logout_user');
              }
            }
          }
          return config;
        },
        responseError: function (config) {
          return config;
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/httpInterceptors.js